import { IconChevronRight } from '@tabler/icons-react'
import type React from 'react'
import { MyNaviTypography } from '../MyNaviUI/MyNaviTypography'
import styles from './MyNaviVerticalNavigation.module.css'

export type MyNaviNavigationItem = {
  icon: React.ReactNode
  label: string
  /** 選択済みの場合に表示するテキスト */
  selectedValue?: string
  onClick: () => void
}

export type MyNaviVerticalNavigationProps = {
  items: MyNaviNavigationItem[]
}

export const MyNaviVerticalNavigation = ({ items }: MyNaviVerticalNavigationProps) => {
  return (
    <div
      style={{
        backgroundColor: '#fbfbfb',
        border: '1px solid #686868',
        borderRadius: '5px',
        overflow: 'hidden',
      }}
    >
      {items.map((item, index) => (
        <div key={item.label}>
          <button type="button" onClick={item.onClick} className={styles.button}>
            <span style={{ color: '#686868', flexShrink: 0, display: 'flex', alignItems: 'center' }}>{item.icon}</span>
            <span style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '2px' }}>
              <MyNaviTypography variant="label">{item.label}</MyNaviTypography>
              {/* 選択した項目は表示しないようにする */}
              {/*{item.selectedValue && (*/}
              {/*  <span style={{ fontSize: '12px', color: '#058bbe', fontFamily: "'BIZ UDPGothic', sans-serif" }}>*/}
              {/*    {item.selectedValue}*/}
              {/*  </span>*/}
              {/*)}*/}
            </span>
            <IconChevronRight size={20} color="#686868" style={{ flexShrink: 0 }} />
          </button>
          {index < items.length - 1 && <div style={{ height: '1px', backgroundColor: '#686868', margin: '0 16px' }} />}
        </div>
      ))}
    </div>
  )
}
